/*
 * mirailab-product-sections.js
 *
 * 完全再現版: 旧 snippet/product-mirailab*.liquid のフローティングカート JS を
 * 一切ロジック改変せず外部化したもの。
 *
 * 主要機能:
 *  - スクロール監視: .mirailab-lp が画面内に入ったら floating cart を表示
 *  - huckleberry 定期/通常購入の状態取得
 *  - .item-block-detail へのスムーススクロール (購入セクション誘導)
 *  - /cart/add.js による定期/通常購入カート追加
 *  - Beyond テーマ用 theme.cart / theme.off_canvas との連携
 *
 * 変更履歴:
 * - 2026-05-13: v2.0 初版 (Section 完全再現リファクタ)
 */
(function () {
  'use strict';

  const floatingCart = document.getElementById('mirailab-floating-cart');
  const floatingCartBtn = document.getElementById('mirailab-floating-cart-btn');

  // 表示トリガーとなるセクションを探す（優先順位順）
  const triggerSection = document.querySelector('.mirailab-lp') ||
                         document.querySelector('.products-content-area.container') ||
                         document.querySelector('.products-content-area');

  if (!floatingCart || !triggerSection) return;

  // スクロール監視：対象セクションに入ったら表示
  function checkScroll() {
    const sectionRect = triggerSection.getBoundingClientRect();
    const windowHeight = window.innerHeight;

    // セクションが画面内に入ったら表示
    if (sectionRect.top < windowHeight * 0.5 && sectionRect.bottom > windowHeight * 0.3) {
      floatingCart.classList.add('is-visible');
    } else {
      floatingCart.classList.remove('is-visible');
    }
  }

  // スクロールイベント（throttle処理）
  let ticking = false;
  window.addEventListener('scroll', function () {
    if (!ticking) {
      window.requestAnimationFrame(function () {
        checkScroll();
        ticking = false;
      });
      ticking = true;
    }
  });

  // 初回チェック
  checkScroll();

  // huckleberry定期/通常購入の状態を取得する関数
  function getCartData() {
    // 商品IDを取得（複数の方法で試行）
    const productIdMatch = document.querySelector('[id^="subscription-radio-"]');
    const productId = productIdMatch ? productIdMatch.id.replace('subscription-radio-', '') : null;

    // 定期購入ラジオボタン
    const subscriptionRadio = productId ? document.getElementById('subscription-radio-' + productId) : null;
    // 通常購入ラジオボタン
    const regularRadio = productId ? document.getElementById('regular-radio-' + productId) : null;

    // 定期購入が選択されているかチェック（デフォルトは定期購入）
    const isSubscription = subscriptionRadio ? subscriptionRadio.checked : true;

    if (isSubscription) {
      // 定期購入の場合
      const variantIdInput = document.querySelector('.huckleberry-variant-id');
      const sellingPlanInput = document.querySelector('.huckleberry-selling-plan');
      const selectedCycle = document.querySelector('.huckleberry-cycle-option.selected');

      const variantId = variantIdInput ? variantIdInput.value : null;
      let sellingPlan = sellingPlanInput ? sellingPlanInput.value : null;

      // selling planが空の場合、選択されているサイクルオプションから取得
      if (!sellingPlan && selectedCycle) {
        sellingPlan = selectedCycle.dataset.planId;
      }

      const sellingPlanName = selectedCycle ? selectedCycle.dataset.planName : '';

      return {
        isSubscription: true,
        variantId: variantId,
        sellingPlan: sellingPlan,
        sellingPlanName: sellingPlanName
      };
    } else {
      // 通常購入の場合
      const variantIdInput = document.querySelector('.huckleberry-regular-variant-id');
      const variantId = variantIdInput ? variantIdInput.value : null;

      return {
        isSubscription: false,
        variantId: variantId,
        sellingPlan: null,
        sellingPlanName: null
      };
    }
  }

  // フォールバック：従来の方法でバリアントIDを取得
  function getFallbackVariantId() {
    // ラジオボタンで選択されているバリアント
    const checkedRadio = document.querySelector('input[name="id"]:checked');
    if (checkedRadio) return checkedRadio.value;

    // セレクトボックスで選択されているバリアント
    const variantSelect = document.querySelector('select[name="id"]');
    if (variantSelect) return variantSelect.value;

    // hidden inputのバリアント
    const hiddenInput = document.querySelector('input[name="id"][type="hidden"]');
    if (hiddenInput) return hiddenInput.value;

    return null;
  }

  // 購入セクションへスクロール
  if (floatingCartBtn) {
    floatingCartBtn.addEventListener('click', function () {
      const targetSection = document.querySelector('.item-block-detail');
      if (targetSection) {
        const headerOffset = 80; // ヘッダーの高さを考慮
        const elementPosition = targetSection.getBoundingClientRect().top;
        const offsetPosition = elementPosition + window.pageYOffset - headerOffset;

        window.scrollTo({
          top: offsetPosition,
          behavior: 'smooth'
        });
      }
    });
  }

  function addToCart(cartData) {
    floatingCartBtn.disabled = true;
    floatingCartBtn.textContent = '追加中...';

    let requestBody;

    if (cartData.isSubscription && cartData.sellingPlan) {
      // 定期購入の場合
      requestBody = {
        items: [{
          id: parseInt(cartData.variantId),
          quantity: 1,
          selling_plan: parseInt(cartData.sellingPlan),
          properties: {
            "プラン名": cartData.sellingPlanName || '',
            "ID": cartData.sellingPlan
          }
        }]
      };
    } else {
      // 通常購入の場合
      requestBody = {
        items: [{
          id: parseInt(cartData.variantId),
          quantity: 1
        }]
      };
    }

    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(requestBody)
    })
      .then(response => response.json())
      .then(async data => {
        floatingCartBtn.textContent = 'カートに追加しました';
        setTimeout(() => {
          floatingCartBtn.disabled = false;
          floatingCartBtn.textContent = 'カートに入れる';
        }, 2000);

        // カートのHTML・合計を更新（Beyond テーマ用）
        if (typeof theme !== 'undefined' && theme.cart) {
          await theme.cart.updateAllHtml();
          theme.cart.updateTotals();
        }

        // カートドロワーを開く（Beyond テーマ用）
        if (typeof theme !== 'undefined' && theme.off_canvas) {
          theme.off_canvas.toggleView('cart');
          theme.off_canvas.toggle('right-sidebar');
        }
      })
      .catch(error => {
        console.error('Error:', error);
        floatingCartBtn.disabled = false;
        floatingCartBtn.textContent = 'カートに入れる';
        alert('カートへの追加に失敗しました。');
      });
  }
})();
